import { IFilter } from "../Tools/IFilter";
import { FilterGroup } from "../Tools/FilterGroup";
import { FiltersController } from "../Tools/FiltersController";
import { checkAndDestroySelect2, globalMatcher, globalTemplateResult } from "../Tools/GlobalMethods";
import { Options } from "select2";

export class ObjectStyleMDMFilter implements IFilter {
    id: string;
    name?: string | null | undefined;
    type: string;

    controller: FiltersController;
    parentGroup: FilterGroup;
    constructor(parentGroup: FilterGroup) {
        this.parentGroup = parentGroup;
        this.id = 'objectStyle';
        this.name = "Style d'objet";
        this.type = 'objectStyle';

        this.controller = new FiltersController();
    }

    html(): string {
        let html = `
        <div class="filter" style="display: flex;flex-direction: column;align-items: center;margin:0 auto;max-width: 380px;width: 100%;">
            <span>${this.name}</span>
            <select id="objectStyleInput" style="width: 100%;" title="${this.name}"></select>
        </div>
        `;

        setTimeout(() => {
            FilterGroup.loadObjectStylesMDM().then(() => {
                if (this.parentGroup.isDestroyed) return;
                checkAndDestroySelect2('objectStyleInput');
                let styles = FilterGroup.objectStylesMDM!.map((element) => {
                    return {
                        id: element._id || '-1',
                        text: element.name,
                        title: this.name,
                        selected: FilterGroup.filters.objectStyle?.includes(element)
                    };
                })

                $('#objectStyleInput').select2({
                    multiple: true,
                    placeholder: {
                        id: '-1',
                        text: 'Choisissez un style'
                    },
                    data: [
                        {
                            id: '-1',
                            text: 'Choisissez un style',
                        },
                        ...styles
                    ],
                    width: 'element',
                    matcher: globalMatcher,
                    templateResult: globalTemplateResult,
                    selectionCssClass: 'select-control',
                } as unknown as Options);

                $('#objectStyleInput').on('change.select2', () => {
                    let selectedValues = $('#objectStyleInput').val() as string[];
                    if (selectedValues.length === 0 || selectedValues[0] === '-1') {
                        FilterGroup.filters.objectStyle = null;
                    } else {
                        FilterGroup.filters.objectStyle = FilterGroup.objectStylesMDM!.filter((element) => selectedValues.includes(element._id)) || null;
                    }
                    FilterGroup.getUpdateFunctions(this.parentGroup.filtersFunction)(FilterGroup.filters);
                });
            });
        });

        return html;
    }

    // Done
    generateStringFilter(): string {
        let stringFilters = "";
        if (FilterGroup.filters.objectStyle !== null && FilterGroup.filters.objectStyle.length > 0) {
            stringFilters += '&q.styles.in=';
            for (let i = 0; i < FilterGroup.filters.objectStyle.length; i++) {
                if (i > 0) {
                    stringFilters += ',';
                }
                stringFilters += FilterGroup.filters.objectStyle[i]._id;
            }
        }
        return(stringFilters);
    }

    destroy(): void {
        $('#objectStyleInput').off('change.select2');
        checkAndDestroySelect2('objectStyleInput');
        this.controller.destroy();
    }
}